import { Avatar, AvatarFallback } from "@loot-os/ui/components/avatar";

/**
 * A player's chat avatar. Shoppers have no profile picture, so it is the first letter of the
 * username on a tint picked from the id: the same player keeps the same color everywhere.
 */
export function ChatAvatar({
  endUserId,
  displayName,
  size = "default",
}: {
  endUserId: string;
  displayName: string;
  size?: "default" | "sm";
}) {
  const hue = [...endUserId].reduce((sum, ch) => (sum * 31 + ch.charCodeAt(0)) % 360, 7);
  return (
    <Avatar size={size} aria-hidden>
      <AvatarFallback
        className="font-semibold text-white"
        style={{ backgroundColor: `hsl(${hue} 45% 38%)` }}
      >
        {(displayName.trim()[0] ?? "?").toUpperCase()}
      </AvatarFallback>
    </Avatar>
  );
}
